import { Tooltip } from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';
import { ColumnsPanelTrigger, FilterPanelTrigger, Toolbar, ToolbarButton } from '@mui/x-data-grid-pro';
import { StyledQuickFilter } from '@components/DataGrid/StyledComponents';
import DensityMenuButton from '@components/DataGrid/ToolbarItems/DensityMenu';

/** Shared DataGrid toolbar for the Agent Settlements tabs that need no tab-specific controls. */
export function SettlementsToolbar() {
  return (
    <Toolbar style={{ justifyContent: 'flex-end' }}>
      <Tooltip title='Columns'>
        <ColumnsPanelTrigger render={<ToolbarButton />}>
          <ViewColumnIcon fontSize='small' />
        </ColumnsPanelTrigger>
      </Tooltip>
      <Tooltip title='Filters'>
        <FilterPanelTrigger render={<ToolbarButton />}>
          <FilterListIcon fontSize='small' />
        </FilterPanelTrigger>
      </Tooltip>
      <DensityMenuButton />
      <StyledQuickFilter />
    </Toolbar>
  );
}
